import { BsExclamationOctagon } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { APP_NAME } from "@utils/constants";

const NotAuthroziedPage = ({ description }) => {
  return (
    <>
      <Helmet>
        <title>{`Not Authorized | ${APP_NAME}`}</title>
      </Helmet>
      <div className="container mx-auto flex flex-col justify-center items-center gap-4 h-full">
        <BsExclamationOctagon color="red" size={60} />
        <h2 className="text-xl mt-4 mb-0">You are not authroized</h2>
        {!description ? (
          <>
            <div className="text-sm">
              <p className="text-center">
                It seems like you don&apos;t have permission to use this page
              </p>
              <p className="text-center">Please contact admin for support.</p>
            </div>
          </>
        ) : (
          description
        )}
      </div>
    </>
  );
};

export default NotAuthroziedPage;
